module.exports = __webpack_public_path__ + "img/logo.74eb020a.png";